var $ = require('jQuery');
var Vue = require('vue');
var fundAllocations = require('../funding/fund-allocations');
var QuickManager = require('../../lib/components/QuickManager/QuickManager.vue').default;
var Contracts = require('./components/Contracts.vue').default;
var EditUser = require('./components/EditUser.vue').default;

module.exports = function() {

    if (typeof funding != 'undefined') {
        new fundAllocations(funding);
    }

    $('#recuse-user').select2({
        ajax: {
            url: '/users/autocomplete/current',
            dataType: 'json',
            delay: 250,
            data: function(searchTerm) {
                return {
                    name: searchTerm
                }
            },
            results: function(data) {
                return {
                    results: data
                }
            },
            cache: true
        },
        formatResult: function(user) {
            return user.firstName + ' ' + user.lastName;
        },
        formatSelection: function(user) {
            return user.firstName + ' ' + user.lastName;
        },
        minimumInputLength: 3
    });

    $('.recusal-show-add').on('click', function() {
        $(this).hide();
        $('.recusal-add form').removeClass('hidden');
    });

    /**
     * Quick Manager
     */
    const quickManager = document.getElementById('quickManager');

    if (quickManager) {
        new Vue({
            el: quickManager,
            components: {
                'quick-manager': QuickManager
            }
        });
    }

    /**
     * Contracts
     */
    const contracts = document.getElementById('contracts');

    if (contracts) {
        new Vue({
            el: contracts,
            components: {
                'contracts': Contracts
            }
        });
    }

    /**
     * Edit User
     */
    const editUser = document.getElementById('edit-user');

    if (editUser) {
        new Vue({
            el: editUser,
            components: {
                'edit-user': EditUser
            }
        });
    }
};
